import { firestore } from '@/firebaseConfig'
import News from '../model/News';

export default class NewsFeedService {
    loadLatestNews() {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("newsFeed").orderBy("publicationDate", "desc").limit(5).get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new News(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }
}
